import clsx from 'clsx';
import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { ClickTarget, click } from '@tracking';

import { OrgChartsGridItemProps } from './interfaces';

const OrgChartsGridItem = ({
  company: { slug, title, companyLogo, companyLogoFullColor },
}: OrgChartsGridItemProps) => {
  const { trackEvent } = useEventTracking();
  const hasFullColorLogo = !!companyLogoFullColor;

  return (
    <a
      className="group flex aspect-[1/1] w-full items-center justify-center bg-white transition-colors duration-200 hover:cursor-pointer hover:bg-grayscale-beige"
      href={`/org-charts/${slug}`}
      onClick={() =>
        trackEvent(click({ clickTarget: ClickTarget.OrgChartGridViewItem, value: slug }))
      }
    >
      {hasFullColorLogo ? (
        <div className="relative flex h-full w-full items-center justify-center">
          {/* Default logo (visible by default, hidden on hover) */}
          <img
            loading="lazy"
            src={companyLogo}
            alt={`${title} company logo`}
            className={
              'absolute max-h-[80%] max-w-[80%] object-contain transition-all duration-300 group-hover:scale-105 group-hover:opacity-0'
            }
          />

          {/* Full-color logo (hidden by default, visible on hover) */}
          <img
            loading="lazy"
            id={`${slug}-full-color`}
            src={companyLogoFullColor}
            alt={`${title}`}
            className={clsx(
              'absolute max-h-[80%] max-w-[80%] object-contain opacity-0 transition-all duration-300',
              'group-hover:scale-105 group-hover:opacity-100'
            )}
          />
        </div>
      ) : (
        // If no full color logo, just use the default logo with scaling
        <img
          loading="lazy"
          id={slug}
          src={companyLogo}
          alt={title}
          className={
            'max-h-[80%] max-w-[80%] object-contain opacity-50 transition-all duration-300 group-hover:scale-105 group-hover:opacity-100'
          }
        />
      )}
    </a>
  );
};

export default OrgChartsGridItem;
